import { watch } from 'vue';
import { quizStatusRevision } from '@/services/QuizStatusTransition.js';
import quizWaitingRoomService from '@/services/quizWaitingRoomService.js';

const DISCOVERABLE_STATUSES = ['in-waiting-room', 'ready-to-start', 'attempt-started', 'in-waiting-room-post'];

// Recover the first missed broadcast from the existing online heartbeat. Fetch
// status before presenting anything: an active ID alone does not mean Start.
export function useQuizAttemptDiscovery({ onlineResponse, routeName, shouldDiscover, onDiscovered }) {
    watch(
        [onlineResponse, routeName],
        async ([response], _previous, onCleanup) => {
            const attemptId = Number(response?.meta?.quiz_active_id);
            if (!Number.isSafeInteger(attemptId) || attemptId <= 0 || !shouldDiscover(attemptId)) return;
            const controller = new AbortController();
            const revision = quizStatusRevision();
            onCleanup(() => controller.abort());
            try {
                const attempt = await quizWaitingRoomService.getStatus(attemptId, controller.signal);
                if (
                    controller.signal.aborted ||
                    quizStatusRevision() !== revision ||
                    !shouldDiscover(attemptId) ||
                    Number(attempt?.id) !== attemptId ||
                    !DISCOVERABLE_STATUSES.includes(attempt?.status)
                )
                    return;
                await onDiscovered({ ...attempt, id: attemptId });
            } catch {
                // A later heartbeat retries; never interrupt the current page.
            }
        },
        { immediate: true }
    );
}
